import type { EventId } from "~domain/events/models/event-model.ts";

import { z } from "zod";

export const backofficeFindLastHardwareConfigurationResponse = z.void().or(
  z
    .object({
      id: z.number().transform((s) => s as EventId),
      createDateTime: z.coerce.date(),
    })
    .nullish(),
);
